import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { ReportService } from "../report.service";
import * as moment from "moment";

@Component({
	selector: "app-report-maintenance",
	templateUrl: "./report-maintenance.component.html",
	styleUrls: ["./report-maintenance.component.css"],
})
export class ReportMaintenanceComponent implements OnInit {
	constructor(private reportService: ReportService, private confirmationService: ConfirmationService) {}

	ngOnInit(): void {
		this.loadReport();
	}

	////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////

	// Directory: any = "C:\Program Files (x86)\Access411\CAASS Server\WebServices\ReportsWCF\Reports";
	Directory: any = "";
	SchoolID: any = 0;

	processing: any = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedReport: any;
	lstReport: any = [];

	//Filter lists
	lstReportGroupDesc: any = [];
	lstDisplayInReports: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "ReportID", header: "Report ID" },
		{ field: "ReportDisplayName", header: "Display Name" },
		{ field: "ReportFileName", header: "File Name" },
		{ field: "ReportGroupDesc", header: "Group" },
		{ field: "ReportDTDesc", header: "Last Update" },
		{ field: "ParmString", header: "Parameters" },
		{ field: "DisplayInReports", header: "Display In Reports Section" },
	];

	///////////////

	////////////////////////////////////////////////

	////////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////////

	loadReport() {
		this.loading = true;

		var result = this.reportService.ReportTableGetList();
		result.subscribe(
			(response) => {
				this.lstReport = response;

				for (var i = 0; i < this.lstReport.length; i++) {
					var next = this.lstReport[i];

					next.ReportDTDesc = moment(new Date(next.ReportDT)).format("MM/DD/YYYY h:mm a");
				}

				//Load Data Filter Lists
				this.lstReportGroupDesc = Array.from(new Set(this.lstReport.map((item: any) => item.ReportGroupDesc))).sort();
				this.lstDisplayInReports = Array.from(new Set(this.lstReport.map((item: any) => item.DisplayInReports))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}
	////////////////////////////////////////////////

	////////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////////

	onRefresh() {
		this.loadReport();
	}

	onImport() {
		this.errorMessage = "";

		this.processing = true;

		var result = this.reportService.ReportImport(this.Directory, this.SchoolID);
		result.subscribe(
			(response) => {
				var MSG = this.ReplaceAll(String(response), '"', "");

				this.confirmationService.confirm({
					key: "main",
					acceptLabel: "Ok",
					rejectVisible: false,
					message: MSG,
					header: "Response",
					icon: "fa",
					accept: () => {
						this.processing = false;
						this.loadReport();
					},
				});
			},
			(error) => {
				var MSG = error;

				this.confirmationService.confirm({
					key: "main",
					acceptLabel: "Ok",
					rejectVisible: false,
					message: MSG,
					header: "Error",
					icon: "fa",
					accept: () => {
						this.processing = false;
						this.loadReport();
					},
				});
			}
		);
	}

	onExport() {
		this.errorMessage = "";

		if (this.loading == true || this.processing == true) {
			return;
		}

		if (this.SelectedReport == undefined) {
			this.errorMessage = "Select a Report to Export";
			return;
		}

		this.processing = true;

		var result = this.reportService.ReportExport(this.SelectedReport.ReportID);
		result.subscribe(
			(response) => {
				var MSG = this.ReplaceAll(String(response), '"', "");
				MSG = this.ReplaceAll(String(MSG), "\\\\", "\\");

				this.confirmationService.confirm({
					key: "main",
					acceptLabel: "Ok",
					rejectVisible: false,
					message: MSG,
					header: "Response",
					icon: "fa",
					accept: () => {
						this.processing = false;
					},
				});
			},
			(error) => {
				var MSG = error;

				this.confirmationService.confirm({
					key: "main",
					acceptLabel: "Ok",
					rejectVisible: false,
					message: MSG,
					header: "Error",
					icon: "fa",
					accept: () => {
						this.processing = false;
					},
				});
			}
		);
	}

	////////////////////////////////////////////////

	////////////////////////////////////////////////
	// Events
	////////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";

		this.SelectedReport = val.data;
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		this.SelectedReport = null;
	}
	onRowDblClick(Report) {
		this.errorMessage = "";

		this.SelectedReport = Report;
		this.onExport();
	}
	////////////////////////////////////////////////

	////////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////////
	ReplaceAll(str: string, f: string, r: string) {
		while (str.indexOf(f) != -1) {
			str = str.replace(f, r);
		}

		return str;
	}
	////////////////////////////////////////////////
}
